import { OmniIconComponent } from "../../../../shared";

export function FiltersMenu({
  handleExportMenuItemClick,
  handleImportMenuItemClick,
}) {
  return (
    <div className="ag-grid-filter-wrapper">
      <div className="filter-container-hamburger">
        <omni-menu offsetTop="24">
          <button className="icon" slot="target">
            <omni-icon
              aria-hidden="true"
              icon-id="omni:informative:menu"
            ></omni-icon>
          </button>
          {[
            {
              icon: "omni:interactive:export",
              label: "Export table as CSV",
              clickListener: handleExportMenuItemClick,
            },
            {
              icon: "omni:interactive:upload",
              label: "Import campaigns",
              clickListener: handleImportMenuItemClick,
            },
          ].map(({ label, icon, clickListener }) => (
            <div className="item" key={label} onClick={clickListener}>
              <OmniIconComponent icon-id={icon} />
              {label}
            </div>
          ))}
        </omni-menu>
      </div>
    </div>
  );
}
